/**
 * i18n — von der ersten Zeile an, nicht als Nachtrag.
 *
 * `de` ist Vorgabe, `en` ist verbindlich (CLAUDE.md Abschnitt 1: jordanische
 * Mitarbeiter). Key-Schema `<modul>.<kontext>.<element>` — dasselbe Schema wie
 * im Backend, damit ein Fehlercode `api.error.rate_limited` hier ohne Umrechnung
 * ankommt.
 *
 * Die Kataloge werden mitgebaut, nicht nachgeladen: bei zwei Sprachen und
 * wenigen Kilobyte waere ein Nachladeweg mehr Fehlerquelle als Ersparnis — und
 * eine halb uebersetzte Oberflaeche waehrend des Ladens gaebe es dann auch.
 */
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import de from './de.json'
import en from './en.json'

export const SPRACHEN = ['de', 'en'] as const
export type Sprache = (typeof SPRACHEN)[number]

export const VORGABE: Sprache = 'de'

// `void` statt `await`: die Kataloge liegen als Objekt vor, also ist die
// Initialisierung sofort fertig. Ein top-level await machte aus jedem Importeur
// dieses Moduls ein asynchrones Modul — fuer nichts.
void i18next.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: VORGABE,
  // Fehlt ein Key in `en`, erscheint der deutsche Text — nicht der nackte Key.
  // Ein sichtbarer Rohkey ist fuer den Leser wertlos; dass er fehlt, faengt die
  // Katalogpruefung ab (IS-35), nicht die Laufzeit.
  fallbackLng: VORGABE,
  supportedLngs: SPRACHEN,
  interpolation: {
    // React entschaerft selbst. Doppelt entschaerft macht aus einem "&" ein
    // "&amp;" im Text.
    escapeValue: false,
  },
})

/**
 * Sprache umstellen und das `lang`-Attribut nachziehen.
 *
 * Ohne `lang` liest der Screenreader englische Saetze mit deutscher Aussprache
 * vor, und die Silbentrennung des Browsers arbeitet nach der falschen Sprache.
 * Deshalb gehoert beides zusammen — und darum gibt es dafuer eine Funktion und
 * nicht zwei Aufrufe an der Bedienstelle.
 */
export async function setzeSprache(sprache: Sprache): Promise<void> {
  await i18next.changeLanguage(sprache)
  document.documentElement.lang = sprache
}

export default i18next
